<template>
  <v-layout class="pl-wrapper" column justify-center fill-height>
    <v-layout v-show="load" class="pl-wrapper" column justify-center fill-height>
      <preloader />
    </v-layout>

    <v-layout v-show="!load" class="pl-wrapper" column justify-center fill-height>
      <div class="container-local fluid pl-employers">
        <v-layout class="pl-panel pl-block" row wrap>
          <v-btn
            v-for="item in tabs"
            :key="item.id"
            :class="{ 'pl-btn_primary': $route.name === item.id }"
            class="pl-btn pl-btn_default"
            @click="changeTab(item.id)"
          >
            {{ item.name }}
          </v-btn>
        </v-layout>

        <v-divider />
      </div>
      <slot> </slot>
    </v-layout>
  </v-layout>
</template>

<script>
import Preloader from '@/components/Preloader/Preloader'
import { mapGetters } from 'vuex'

export default {
  name: 'wrapperWithTabs',
  components: {
    preloader: Preloader,
  },
  props: {
    tabs: {
      type: Array,
    },
  },
  created() {},
  computed: {
    ...mapGetters(['load']),
  },
  methods: {
    changeTab(id) {
      if (this.$route.name !== id) this.$router.push({ name: id })
      else return
    },
  },
}
</script>

<style scoped>
.container-local {
  padding: 24px 24px 0;
}
</style>
